import { render, staticRenderFns } from "./UnidentifiedReturnsList.vue?vue&type=template&id=22bd484a&scoped=true"
import script from "./UnidentifiedReturnsList.vue?vue&type=script&lang=js"
export * from "./UnidentifiedReturnsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bd484a",
  null
  
)

export default component.exports